import script from "./kalio-list-item-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./kalio-list-item-card.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__